
import { Container, delayedCall, dispatcher, ingenuity, IObject, ITween, killDelayedCall, SpineBase } from "@quest/base-core";
import { HoldAndRespinModel } from "../Model/HoldAndRespinModel";
import { HoldAndRespinView } from "../View/HoldAndRespinView";
import { eventDispatchers } from "../../Constants/EventDispatchers";
import { GameParserModel } from "../../Platform/GameParserModel";
import { Emitter } from "@quest/pixi-bridge";
import { SoundConstantGame } from "../../Constants/SoundConstantGame";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BehaviorConstants/SlotConstantsBehavior";
import { gameConstants } from "../../Constants/gameConstants";

export class AutoPilotBaitController {

    private  readonly view: HoldAndRespinView;
    private  readonly model: HoldAndRespinModel;
    private movingBaitReelsContainer: Container
    constructor(view: HoldAndRespinView, model: HoldAndRespinModel) {
        this.view = view;
        this.model = model;
        this.subscribeEvents();
        this.initializeElements();
    }
    private initializeElements() {
        this.movingBaitReelsContainer = this.view.getContainerByID("movingBaitReelsContainer");
    }
    private subscribeEvents(): void {
        this.unSubscribeEvents();
        dispatcher.on(eventDispatchers.MOVE_AUTO_PILOT_BAIT, this.showMovingBaitSymbol, this)
    }
    private unSubscribeEvents(): void {
        dispatcher.off(eventDispatchers.MOVE_AUTO_PILOT_BAIT, this.showMovingBaitSymbol, this)
    }
    /**
     * to show moving symbol for auto pilot bait
     */
    private showMovingBaitSymbol(): void {
        (ingenuity.parserModel as GameParserModel).getPositionBaitPosition().forEach((offset: number[]) => {
            this.model.getStoppedReels().splice(this.model.getStoppedReels().indexOf(offset[0]), 1);
            dispatcher.fireEvent(eventDispatchers.UPDATE_REEL_SYMBOL, { symbolNumber: this.model.getConvertedBaitSymbol(), reel: offset[0] })
            this.showAutoBaitSymbol(offset[0], offset[1])
        })
        delayedCall("autoBaitCompleted", 1500, () => {
            killDelayedCall("autoBaitCompleted");
            dispatcher.fireEvent(eventDispatchers.SEND_NEXT_SPIN_FLOW);
            this.resetBaits();
        }, this);
    }



    // starting point for spine , contaner and trail
    private showAutoBaitSymbol(initalPos: number, finalPos: number): void {
        const movingContainer = this.createMovingSymbol(initalPos);
        this.initializeCoinShowerEmitter(movingContainer, initalPos)
        this.playTrailAnimation(finalPos, movingContainer);
    }
    /**
     * to create spine symbol
     * */
    private createMovingSymbol(initialPos: number): Container {
        const row: number = this.model.getPosToOffset(initialPos)[0]
        const col: number = this.model.getPosToOffset(initialPos)[1]
        const AutoBait: SpineBase = this.view.createSpineAnimation("autoBaitMove_" + (ingenuity.parserModel as GameParserModel).getTriggeredBait());
        const movingContainer: Container = this.view.createContainerClone("movingBaitReelsContainer");
        movingContainer.addChild(AutoBait)
        AutoBait.setPause(false)
        AutoBait.playAnim((AutoBait.json as any).animName, true)
        movingContainer.x = row * this.view.json.symWidth;
        movingContainer.y = col * this.view.json.symHeight;
        movingContainer.name = this.view.json.movingBaitContainer.name + "_" + row + "_" + col;
        this.movingBaitReelsContainer.addChild(movingContainer);
        return movingContainer;
    }
    /**
       * Initialize Data for Emmiter
       */
    private initializeCoinShowerEmitter(movingContainer: Container, initalPos: number): void {
        const particleData: any = {
            emitterType: 0,
            id: "winCoinEmitter",
            autoStart: false,
            image: [
                "Bubble_blue_0",
                "Bubble_blue_0",
                "Blue_Pixel_8",
                "Blue_star_13",
                "Green_bubble",
                "Green_bubble",
                "White_bubble",
                "White_star",
                "Yellow_bubble",
                "Yellow_Pixel_1"
            ],
        };
        const config = {
            alpha: {
                start: 0.6,
                end: 1
            },
            scale: {
                start: 0.6,
                end: 0.9,
                minimumScaleMultiplier: 0.5
            },
            color: {
                start: "#ffffff",
                end: "#ffffff"
            },
            speed: {
                start: 20,
                end: 30,
                minimumSpeedMultiplier: 1
            },
            acceleration: {
                x: 0,
                y: 0
            },
            maxSpeed: 0,
            startRotation: {
                min: 0,
                max: 360
            },
            noRotation: false,
            rotationSpeed: {
                min: 0,
                max: 0
            },
            lifetime: {
                min: 0.001,
                max: 1
            },
            blendMode: "normal",
            frequency: 0.03,
            emitterLifetime: -1,
            maxParticles: 60,
            pos: {
                x: 0,
                y: 0
            },
            addAtBack: false,
            spawnType: "rect",
            spawnRect: {
                x: -100,
                y: -100,
                w: 200,
                h: 200
            }
        }
        particleData.id = movingContainer.name;
        const bubbleTrail = ingenuity.currentGame.add.emitter(this.view.getContainerByID("bubbleTrailContaier"), particleData, config) as Emitter;
        bubbleTrail.autoUpdate = true;
        bubbleTrail.emit = true;
        // Update emitter position manually
        const initialXPos = this.model.getPosToOffset(initalPos)[0] * this.view.json.symWidth
        const initialYPos = this.model.getPosToOffset(initalPos)[1] * this.view.json.symHeight
        bubbleTrail.updateOwnerPos(initialXPos, initialYPos);
    }

    /**
     * Play tween to move symbol and will update emitter origin point to make it trail
     */
    //
    private playTrailAnimation(finalPos: number, movingBait: Container): void {
        const finalXPos = this.model.getPosToOffset(finalPos)[0] * this.view.json.symWidth
        const finalYPos = this.model.getPosToOffset(finalPos)[1] * this.view.json.symHeight
        const trailTweenscale = ingenuity.currentGame.add.tween(movingBait.scale)
        trailTweenscale.to({ x: 1.3, y: 1.3 }, gameConstants.BAIT_MOVE_SCALE_TIME, undefined, true, 0, 0, true);
        let trailTween: ITween;
        trailTween = ingenuity.currentGame.add.tween(movingBait);
        
        (ingenuity.soundManager as any).playSound(SoundConstantGame.LL_ICON_WIN, 1, false, SlotConstantsBehavior.SOUND_LIST_POSTLOAD);

        trailTween.to({ x: finalXPos, y: finalYPos }, gameConstants.BAIT_MOVE_TIME, undefined, true);
        trailTween.onUpdateCallback((evt: IObject) => {
            let em: Emitter;
            em = ingenuity.currentGame.particles.getEmitterById(evt.target.name);
            em.updateOwnerPos(evt.target.x, evt.target.y);
        });
        trailTween.onComplete.addOnce(() => {
            let em: Emitter;
            em = ingenuity.currentGame.particles.getEmitterById(trailTween.target.name);
            em.autoUpdate = false;
            em.emit = false;
            em.destroy();
            this.onTrailCompleted(finalPos);
            this.removeContainer(movingBait);
            ingenuity.currentGame.tweens.remove(trailTween);
            ingenuity.currentGame.tweens.remove(trailTweenscale);
            trailTween.target.parent.removeChild(trailTween.target);
        }, this);
    }
    private onTrailCompleted(finalPos: number): void {
        dispatcher.fireEvent(eventDispatchers.UPDATE_REEL_SYMBOL, { symbolNumber: this.model.getConvertedBaitSymbol(150), reel: finalPos })
        this.model.setStoppedReels(finalPos);
        dispatcher.fireEvent(eventDispatchers.SHOW_REEL_BEHIND_FISH, finalPos);
        dispatcher.fireEvent(eventDispatchers.PLAY_MOVING_BAIT_IDLE, finalPos);
    }

    private removeContainer(container: Container): void {
        container.children.forEach((child: any) => {
            if (child.json.type === "spine") {
                child.setPause(true);
                child.destroy();
            }
        });
        container.removeChildren();
        container.children = [];
    }
    private resetBaits(): void {
        this.movingBaitReelsContainer.removeChildren();
        this.movingBaitReelsContainer.children = [];
        ingenuity.currentGame.tweens.removeFrom(this);
        const trailContainer = this.view.getContainerByID("bubbleTrailContaier")
        trailContainer.removeChildren();
        trailContainer.children = []
    }
    public resetController():void{
        this.resetBaits();
        this.unSubscribeEvents()
    }
}